import React from 'react'
import { Container, Col, Row } from '@paypalcorp/pp-react'

import PhoneAndCoins from '../../../../icons/phoneandcoins'

import './style.css'

const MakePayments = () => {
  return (
    <section className="makePayments">
      <Container>
        <Row>
          <Col className="makePaymentsLeftCol">
            <PhoneAndCoins />
          </Col>
          <Col className="makePaymentsRightCol">
            <h3 className="makePaymentsTitle">Make Payments</h3>
            <h4 className="makePaymentsSubTitle">Payouts</h4>
            <p className="makePaymentsText">
              Code a solution to send mass payments to contract workers,
              claimants, freelancers, and sellers around the world
            </p>
            <a href="/docs/payouts/" className="getStarted">
              Get started
            </a>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default MakePayments
